Directives.EmailSignatureEditorDirective = function EmailsEditorDirective() {

    // @ngInject
    function EmailSignatureEditorDirectiveCtor($scope, $injector, $, AnalyticsService, ModalService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'EmailSignatureEditorDirectiveController';
        this.$scope = $scope;
        this.ModalService = ModalService;
        this.AnalyticsService = AnalyticsService;
        this.$ = $;
        this.editorReference = null;
        this.version = this.emailSignatureModel.version;
        this.$destroyed = false;
        this.cloudinaryTransformationArray = [ {
            width: '100',
            height: '100',
            crop: 'scale',
            flags: 'lossy',
            dpr: '2',
            fetch_format: 'auto'
        }];

        this.uploadModalOptions = {showCropTab: true,
            imageDisplayRatio: 1,
            title: 'MEDIA_MODAL.TITLE._ADD_YOUR_LOGO_'
        };

        // migration for old email signatures
        $scope.$watch('emailSignatureEditorVm.editorReference', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (!this.version) {
                    var editorDataString = this.editorReference.getData();

                    // 1) Image migration
                    // ---------------------
                    // add float-left class to images, to make images stick to left
                    editorDataString = editorDataString.replace('class="image"', 'class="image image-style-align-left"');

                    // 2. Heading migration
                    // ---------------------
                    // migrate h1, h2, h3 into ck5 heading classes:
                    // <h1> -> <span class="text-huge">
                    // <h2>, <h3> -> <span class="text-big">
                    // </h1>, </h2>, </h3> -> </span>

                    editorDataString = editorDataString.replace(/<h1>/g, '<span class="text-huge">');
                    editorDataString = editorDataString.replace(/<h2>/g, '<span class="text-big">');
                    editorDataString = editorDataString.replace(/<h3>/g, '<span class="text-big">');
                    editorDataString = editorDataString.replace(/<\/h1>/g, '<\/span>');
                    editorDataString = editorDataString.replace(/<\/h2>/g, '<\/span>');
                    editorDataString = editorDataString.replace(/<\/h3>/g, '<\/span>');

                    this.editorReference.setData(editorDataString);
                    this.saveEmailSignature();
                }
            }
        }.bind(this));

        $scope.$on('$destroy', function () {
            if (!this.emailSignatureModel.isBeingDeleted) {
                this.saveEmailSignature();
            }

            // always last
            this.$destroyed = true;
        }.bind(this));

    }


    var EmailSignatureEditorDirectiveController = Class(Controllers.BaseController, {
        constructor: EmailSignatureEditorDirectiveCtor,

        saveEmailSignature : function saveEmailSignature() {
            if (this.editorReference && !this.$destroyed) {
                this.emailSignatureModel.html_body = '<div class="email-signature-placeholder">' + this.editorReference.getData() + '</div>';
                this.emailSignatureModel.version = this.emailSignatureModel.version || 2;
                return this.user.updateEmailSignature(this.emailSignatureModel);
            }
        }

    });

    return {
        scope: {
            emailSignatureModel: '=',
            user: '='
        },
        templateUrl: 'angular/app/modules/core/features/email_signature/email_signature_editor_directive_template.html',
        controller: EmailSignatureEditorDirectiveController,
        controllerAs: 'emailSignatureEditorVm',
        bindToController: true
    };
};
